"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DashboardIcon = function DashboardIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    viewBox: "0 0 24 24"
  }, props), _react.default.createElement("path", {
    d: "M19 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-1.26-4.703a1.012 1.012 0 0 0-1.435 0 1.004 1.004 0 0 0 0 1.444 1.02 1.02 0 0 0 1.434-1.444zM14 15.755a1.982 1.982 0 0 0-.368-1.132L11.494 8l-2.145 6.677c-.194.29-.313.638-.324 1.01L9 15.764h.012v.01c0 1.229 1.116 2.225 2.494 2.225C12.884 18 14 17.004 14 15.774v-.019zM11 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.701 5.293A.992.992 0 0 0 5.997 5 .999.999 0 0 0 5 6c0 .552.446 1 .997 1a.992.992 0 0 0 .704-.293.983.983 0 0 0 0-1.414zM4 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm8 14C5.372 24 0 18.628 0 12S5.372 0 12 0s12 5.372 12 12-5.372 12-12 12z",
    fillRule: "evenodd"
  }));
};

var _default = DashboardIcon;
exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/Icon/icons/DashboardIcon.js